
const EPuapFailure = () => {



    return (
        <>
            <div className="container options">
                <p className="h1 mainHeaderTitle mb-5">
                    Nie udało się wysłać dokumentu na eklektroniczną skrzykę podawczą Urzędu Miasta we Wrocławiu,
                    Deklaracja została zapisana w pamięci przeglądaraki. <br />
                    Prosimy spróbować później.
                </p>
            </div>
        </>
    );
};

export { EPuapFailure };
